import { Grid, List, ListItem, ListItemText, Paper } from "@material-ui/core";
import React from "react";
import { Route } from "react-router-dom";
import { useLocation, useHistory, useRouteMatch } from "react-router-dom";
import { sideStyles } from "../../../styles/sideBarStyle";
import AccessbilitiesTable from "./AccessbilitiesTable";
const Accessbilities = () => {
  const classes = sideStyles();
  const { path } = useRouteMatch();
  const history = useHistory();
  const location = useLocation();
  const pathNames = location.pathname.split("/").filter((x) => x);

  return (
    <Grid
      item
      container
      xs={12}
      spacing={2}
      direction="row"
      style={{ margin: "auto", minHeight: "50vh" }}
    >
      {/* Accessbilities menu section */}
      <Grid item container xs={3} md={2}>
        <Paper style={{ width: "100%" }}>
          <Route path="/system-manegment/accessibilities">
            <List style={{ width: "100%" }}>
              {groups.map((item, index) => {
                return (
                  <ListItem
                    key={index}
                    onClick={() => history.push(`${path}/${item.link}`)}
                    button={
                      pathNames[pathNames.length - 1] === item.link
                        ? false
                        : true
                    }
                    className={
                      pathNames[pathNames.length - 1] === item.link
                        ? classes.activelistItem
                        : null
                    }
                  >
                    <ListItemText>{item.title}</ListItemText>
                  </ListItem>
                );
              })}
            </List>
          </Route>
        </Paper>
      </Grid>
      <Grid item xs={9} md={10}>
        <Paper style={{ width: "100%" }}>
          <Route exact path={`/system-manegment/accessibilities/manager`}>
            <AccessbilitiesTable lists={Managerlists} />
          </Route>
          <Route exact path={`/system-manegment/accessibilities/employee`}>
            <AccessbilitiesTable lists={Employeelists} />
          </Route>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default Accessbilities;

const groups = [
  { title: "مدیر", link: "manager" },
  { title: "کارمند", link: "employee" },
];

const Managerlists = [
  { title: "سفارش ها", status: "Done" },
  { title: "تراکنش ها", status: "Done" },
  { title: "گزارش", status: "Done" },
  { title: "پیام ها", status: "Done" },
  { title: "پشتیبانی", status: "Done" },
  { title: "مدیریت سیستم", status: "Done" },
];
const Employeelists = [
  { title: "سفارش ها", status: "Done" },
  { title: "تراکنش ها", status: "Clear" },
  { title: "گزارش", status: "Clear" },
  { title: "پیام ها", status: "Clear" },
  { title: "پشتیبانی", status: "Done" },
  { title: "مدیریت سیستم", status: "Clear" },
];
